// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import React from 'react'
import { bool, func, object, string } from 'prop-types'

const Radio = props => {
  const {
    disabled,
    input,
    label,
    image,
    value,
    id,
    onChangeCustom,
    onClickCustom,
    title,
  } = props

  const onChangeC = e => onChangeCustom(e, input.onChange)
  const onClickC = e => onClickCustom(e, input)

  return (
    <div>
      <label
        className={'radio-option' + (disabled ? ' disabled' : '')}
        title={title || label || ''}>
        <span id={`${id}-label-top`}>{label}</span>
        { image && <img src={image} /> }
        <input
          {...input}
          id={id}
          checked={input.value === value}
          disabled={disabled}
          onBlur={() => false}
          onChange={onChangeCustom ? onChangeC : input.onChange}
          onClick={onClickCustom ? onClickC : input.onClick}
          type={'radio'}
          value={value} />
        <p id={`${id}-label-bottom`}>{label}</p>
      </label>
    </div>
  )
}

Radio.propTypes = {
  disabled: bool,
  id: string,
  image: string,
  input: object.isRequired,
  label: string.isRequired,
  onChangeCustom: func,
  onClickCustom: func,
  title: string,
  value: string.isRequired,
}

export default Radio
